<template>
  <div class="faq-page">
<h2>はじめての方へ</h2>
<el-collapse>
  <el-collapse-item title="占いTVとは？" name="first1">
    占いTVは、予約の取れない人気占い師の占い2,000メニュー以上が占い放題のサブスクリプション（月額定額）サービスです。<br>
    <br>
    <small>※サブスクリプションに含まれていない占いサービスも一部ございます。</small>
  </el-collapse-item>
  <el-collapse-item title="会員登録は必要？" name="first2">
    占いTVのご利用には会員登録（アカウント登録）が必要です。アカウント登録は、メールアドレスとパスワード、LINEアカウント、Twitterアカウントのいずれかで行えます。アカウント登録後にサブスクリプションにお申し込みいただくと、占いTVをお楽しみいただけます。<br>
    <br>
    <a href="/user/input">アカウント登録はこちら</a>
  </el-collapse-item>
  <el-collapse-item title="占いTVの利用料は？" name="first3">
    占いTVのサブスクリプションは月額定額制です。毎月同じ日に利用料の決済が行われます。<br>
    <br>
    <b>・利用料</b><br>
    月額528円（税込） <br>
    <br>
    <b>・決済日</b><br>
    <!--
    サブスクリプション登録が完了した日から15日目に初回のご利用料金が決済されます（<small>※初回サブスクリプション登録完了から2週間は無料期間です</small>）。次月以降は初回決済日と同じ日付で決済が行われます。決済日の日付がない場合（31日等）は、代わりにその月の最終日が決済日となります。 <br>
    <br>
    <small>例）2020年5月1日にサブスクリプション登録した場合、2020年5月15日に2020年6月14日までの利用料の決済が行われます。次月以降は毎月15日に決済が行われます。</small><br>
    -->
    サブスクリプション登録が完了した日にご利用料金が決済されます。次月以降は初回決済日と同じ日付で決済が行われます。決済日の日付がない場合（<small>31日等</small>）は、代わりにその月の最終日が決済日となります。<br>
    <br>
    <small>例）2020年5月1日にサブスクリプション登録した場合、2020年5月1日に2020年5月31日までの利用料の決済が行われます。次月以降は毎月1日に決済が行われます。</small><br>
    <br>
    <b>・お支払い方法</b><br>
    クレジットカード払い、Amazon Payがご利用いただけます。ご利用可能なクレジットカードの種類はVISA、MASTER、JCB、アメリカン・エキスプレスです。お支払い日は各クレジットカード会社により異なりますので、ご使用のクレジットカード会社までお問い合わせください。<br>
    <br>
    <small>※サブスクリプションに含まれていない一部の占いサービス（「超運2022年の運勢」「オーダーメイド型占い」など）は、キャリア決済（携帯電話料金とまとめてお支払い）、Pay決済（PayPay、LINE Pay、Amazon Pay）でも購入いただけます。</small>
  </el-collapse-item>
  <el-collapse-item title="解約はすぐにできる？" name="first4">
    占いTVのサブスクリプションはいつでも簡単に解約できます。解約にかかる手数料は一切ありません。解約後もアカウント情報は削除されませんので、いつでも利用再開することができます（アカウント情報の保存期間は10か月間です）。<br>
    <br>
    <small>※日割りによる清算はありません。月の途中で解約の申し込みを行った場合でも、当月の月額利用金が満額で発生します（次回更新日の前日まで占いTVを利用いただけます）。</small>
  </el-collapse-item>
  <el-collapse-item v-if="isSubscTrial" title="2週間お試し無料とは？" name="first5">
    初回のサブスクリプション登録から2週間、無料で占いTVをお試しいただけます。お試し期間中に解約すれば利用料は発生しません。<br>
    <br>
    <small>
      ※新規登録による無料お試しはおひとり様1回までです。<br>
      ※サブスクリプション登録日を1日目とし、14日目までの間無料でお楽しみいただけます。<br>
      ※無料期間終了後は自動継続となり、月額利用料（税込1,078円 ）が発生します。<br>
      ※サブスクリプションに含まれていない占いサービスは、お試し期間中も有料となります。
    </small><br>
    <br>
    <a href="/user/input">2週間お試し無料に申し込む</a>
  </el-collapse-item>
  <el-collapse-item title="推奨環境について" name="first6">
    占いTVを快適にご利用いただくために、以下の環境でのご利用を推奨しています。<br>
    <small>
      ※推奨環境を満たしていない場合、正常に動作しない可能性があります。<br>
      ※推奨環境下でも、OSとブラウザの組み合わせ、ブラウザの設定状況によっては正常に動作しない場合があります。
    </small><br>
    <br>
    <b>【iPhone/iPad】</b><br>
    OS：iOS11.0以降<br>
    ブラウザ：Safari最新版<br>
    <br>
    <b>【Android/Tablet】</b><br>
    OS：Android 6.0以降<br>
    ブラウザ：Chrome最新版<br>
    <br>
    <b>【パソコン】</b><br>
    ブラウザ：Chrome最新版、Safari最新版（Mac）、Edge最新版（Windows）
  </el-collapse-item>
</el-collapse>

<h2>ご利用方法</h2>
<el-collapse>
  <el-collapse-item title="登録メールアドレスを変更したい" name="howto1">
    占いTVにログインの上、画面右上のアカウントメニュー内の「<a href="/user/account">アカウント情報を管理</a>」で新しいメールアドレスに変更いただけます。
  </el-collapse-item>
  <el-collapse-item title="パスワードを変更したい" name="howto2">
    占いTVにログインの上、画面右上のアカウントメニュー内の「<a href="/user/account">アカウント情報を管理</a>」で新しいパスワードに変更いただけます。<br>
    <br>
    <a href="/user/password">パスワードを忘れてしまった場合はこちら</a>
  </el-collapse-item>
  <el-collapse-item title="お支払い方法について" name="howto3">
    占いTVのサブスクリプションは、クレジットカード、Amazon Payでのお支払いが利用いただけます。<br>
    <br>
    <b>・お支払い方法</b><br>
    クレジットカード払い、Amazon Payがご利用いただけます。ご利用可能なクレジットカードの種類はVISA、MASTER、JCB、アメリカン・エキスプレスです。お支払い日は各クレジットカード会社により異なりますので、ご使用のクレジットカード会社までお問い合わせください。<br>
    <br>
    <small>※サブスクリプションに含まれていない一部の占いサービス（「超運2022年の運勢」「オーダーメイド型占い」など）は、キャリア決済（携帯電話料金とまとめてお支払い）、Pay決済（PayPay、LINE Pay、Amazon Pay）でも購入いただけます。</small>
  </el-collapse-item>
  <el-collapse-item title="クレジットカード情報を変更したい" name="howto4">
    占いTVにログインの上、画面右上のアカウントメニュー内の「<a href="/user/account/status">お支払い情報の管理</a>」で新しいクレジットカード情報に変更いただけます。
  </el-collapse-item>
  <el-collapse-item title="ポイントとはなんですか？" name="howto5">
    占いTVでのご購入代金（税込）の5%がポイントとして付与され、占いTV内の有料占いサービスや特典のお申し込みに利用いただけます。無料期間終了後もサブスクリプションを継続されたお客様には、初回登録特典として500ポイントをプレゼントいたします。サブスクリプションを継続中のお客様には、毎月決済後に27ポイントが付与されます。<br>
    <br>
    <small>※サブスクリプション利用料のお支払いにポイントを使用することはできません。</small>
  </el-collapse-item>
  <el-collapse-item title="メールマガジンの配信を停止したい" name="howto6">
    メールマガジンの配信停止をご希望の場合は、こちらから設定を変更してください。<br>　
    <br>
    <a href="/user/account/magazine">メールマガジンを管理</a><br>
    <br>
    <small>※メールマガジンの解除が反映されるまで3〜5営業日かかります。その間にメールマガジンが届く可能性がございますので、予めご了承ください。</small><br>
    <br>
    <b>・メールマガジン配信停止後もメールが届く場合</b><br>
    占いTVからのお知らせやキャンペーンメールの配信を停止している場合でも、個人情報の取り扱いや個人情報保護方針、規約の改定・更新など、サービスに関する重要な情報に限り、登録メールアドレス宛にお知らせいたします。
  </el-collapse-item>
  <el-collapse-item title="解約方法を教えて下さい" name="howto7">
    ▼サブスクリプション（月額制使い放題）の「解約」をご希望の場合<br>
    ログイン > 画面上部「マイページ」 > サブスクリプションの解約<br><br>
    <small>※日割りによる清算はありません。月の途中で解約の申し込みを行った場合でも、当月の月額利用金が満額で発生します。</small><br><br>
    ▼無料IDの削除（占いTVの退会）をご希望の場合<br>
    <a href="/help/inquiry" style="font-weight: bold">お問い合わせ</a>にて承ります。
  </el-collapse-item>
</el-collapse>

<h2>サービスについて</h2>
<el-collapse>
  <el-collapse-item title="動画が再生できない" name="service1">
    以下をお試しいただき、改善しない場合には<a href="/help/inquiry">お問い合わせ</a>ください。<br>
    <b>
      1．スマートフォンを再起動<br>
      2．ブラウザのキャッシュをクリア<br>
      3．通信環境の良いところで再度動画を再生
    </b><br>
  </el-collapse-item>
  <el-collapse-item title="購入した動画の閲覧制限はありますか？" name="service2">
    ご購入いただいた動画には閲覧期限（動画をお届けした日から１年間）があります。詳しい日付は「申込・購入済み」の一覧からご確認いただけます。閲覧回数には制限はありません。
  </el-collapse-item>
  <el-collapse-item title="動画URLを押しても開きません" name="service3">
    URLがタップできない現象は、お客様が使用中のメーラーが原因と考えられます。動画にアクセスできない場合はURL全てをコピーし、ブラウザのURL入力欄に貼り付けてください。貼り付けの際はURLの前後に空白が入らないようご注意ください。
  </el-collapse-item>
  <el-collapse-item title="どんなことを占ってもらえますか" name="service4">
    基本的にどのようなことでも占えますが、妊娠、医療、犯罪に関する内容はお受けできません。それ以外でも、お申し込み内容によっては鑑定をお断りする場合がありますので予めご了承ください。
  </el-collapse-item>
  <el-collapse-item title="動画の申し込み内容を変更したい" name="service5">
    原則としてお申し込み後の変更はできません。
  </el-collapse-item>
</el-collapse>

  </div>
</template>

<script>
export default {
  name: "FaqPage",
  props: {
    url: {
      type: String,
      default: ''
    },
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.faq-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 0 30px;
  margin: 0 -16px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  b {
    font-weight: bold;
  }
  small {
    font-size: 11px;
    font-size: inherit;
  }
}
</style>

<style lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.faq-page {
  .el-collapse-item__header {
    color: $col_temp_key1;
    font-size: 14px;
    font-weight: 700;
    padding-left: 20px;
    background: none;
    &.is-active {
      color: $col_temp_key1;
      font-size: 14px;
    }
  }
  .el-collapse-item__arrow {
    position: static;
    float: none;
    margin: 0;
    transform: none;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 14px;
      margin: auto;
      width: 24px;
      height: 24px;
      background: url('/static/img/common/arrow_right.svg') no-repeat 50% 50%/contain;
      transition: transform .3s;
    }
    &.is-active {
      &::before {
        transform: rotate(90deg);
      }
    }
  }
  .el-collapse-item__content {
    padding: 0 20px 25px;
  }
  .el-collapse-item__wrap {
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Faq.vue